import { APP_URL } from 'types';

/** End-user premium routes (excludes sysadmin authorisation at /premium/features). */
export function isEndUserPremiumPath(pathname: string): boolean {
  return (
    pathname === APP_URL.PREMIUM_SELF_SERVICE ||
    pathname === APP_URL.BULK_ENQUIRY_LODGEMENT ||
    pathname === APP_URL.BYDA_MEMBER_LOOKUP ||
    pathname === APP_URL.PURCHASE_TRANSACTIONS
  );
}
